import clsx from 'clsx'
import {ButtonHTMLAttributes, forwardRef, ReactNode} from 'react'
import AudioManager from '../../../AudioManager'

const audioManager = new AudioManager()

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'blue' | 'purple' | 'orange' | 'black'
  size?: 'small' | 'large'
  fullWidth?: boolean
  className?: string
  icon?: ReactNode
  id?: string
  ignoreMinWidth?: boolean
}

export const Button = forwardRef<HTMLDivElement | null, IButtonProps>(
  (
    {
      children,
      onClick,
      disabled,
      color = 'blue',
      size = 'large',
      className,
      icon,
      id,
      fullWidth = false,
      ignoreMinWidth = false,
    },
    ref,
  ) => {
    return (
      <div
        className={clsx('relative', fullWidth && 'w-full', className)}
        ref={ref}
        onClick={() => {
          audioManager.SFX.button_click?.volume(0.2)
          audioManager.SFX.button_click?.seek(0)
          audioManager.SFX.button_click?.play()
        }}
      >
        <button
          id={id}
          onClick={onClick}
          disabled={disabled}
          className={clsx(
            'pointer-events-auto h-full px-[30px]',
            'flex flex-col items-center justify-center gap-[4px] rounded-[16px] leading-[1.2]',
            'font-bold uppercase text-white',
            !ignoreMinWidth && '~/lg:~min-w-[200px]/[240px]',
            fullWidth ? 'w-full' : 'w-fit',
            size === 'large' && '~/lg:~py-[20px]/[28px] ~/lg:~text-[24px]/[28px]',
            size === 'small' && 'py-[12px] text-[20px]',
            '-translate-y-[5px] leading-none',
            'transition-transform ease-in-out hover:-translate-y-[3px] active:-translate-y-[3px]',
            color === 'blue' && 'bg-[#004df5fe]',
            color === 'purple' && 'bg-[#b700fffe]',
            color === 'orange' && 'bg-[#f15f2b]',
            color === 'black' && 'bg-[#040100]',
          )}
        >
          {icon && <div>{icon}</div>}
          {children}
        </button>

        <div
          className={clsx(
            'absolute bottom-0 z-[-3] h-[100%] w-full rounded-[16px]',
            'border-b-[8px]',
            color === 'blue' && 'border-[#004df5fe]',
            color === 'purple' && 'border-[#b700fffe]',
            color === 'orange' && 'border-[#C94F24]',
            color === 'black' && 'border-[#040100]',
          )}
        />

        <div
          className={clsx(
            'absolute bottom-0 z-[-2] h-[100%] w-full rounded-[16px]',
            'shadow-[inset_0_-8px_0_0_rgba(0,0,0,0.32)]',
          )}
        />
      </div>
    )
  },
)
